export const blockIconsCommunicationLanNew = (
	<span className='material-symbols-outlined'>lan</span>
);
